import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ItCardComponent, ItIconComponent } from 'design-angular-kit';
import { TranslateModule } from '@ngx-translate/core';
import { IterlexService } from '../iterlex.service';
import type { Authority } from '../interfaces/authority';

@Component({
	selector: 'app-home-page',
	imports: [RouterLink, TranslateModule, ItCardComponent, ItIconComponent],
	templateUrl: './home-page.component.html',
	styleUrl: './home-page.component.scss',
})
export class HomePageComponent implements OnInit {
	private iterlexService = inject(IterlexService);

	authorities: Authority[] = [];
	ngOnInit(): void {
		this.iterlexService.getProfile().subscribe((profile) => {
			this.iterlexService.getAuthorities().subscribe((authorities) => {
				if (profile.roles.some((role) => role.name == 'Admin')) {
					this.authorities = authorities;
				} else {
					for (const authority of authorities) {
						if (
							profile.roles.some(
								(role) =>
									role.name.split('|')[0] == authority.id,
							)
						) {
							this.authorities.push(authority);
						}
					}
				}
			});
		});
	}
}
